import * as React from 'react'
import { tv, VariantProps } from 'tailwind-variants'

const redLabelInformationVariants = tv({
  base: 'flex w-full items-center gap-3 rounded-sm bg-red-50 p-4 text-red-400',
  variants: {
    size: {
      default: 'text-sm',
      lg: 'text-base'
    }
  },
  defaultVariants: {
    size: 'default'
  }
})

const iconVariants = tv({
  base: 'flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full border border-solid border-red-600 bg-transparent text-sm font-bold text-red-600',
  variants: {
    size: {
      default: 'h-6 w-6 text-sm',
      lg: 'h-7 w-7 text-base'
    }
  },
  defaultVariants: {
    size: 'default'
  }
})

export interface RedLabelInformationProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof redLabelInformationVariants> {
  children: React.ReactNode
  icon?: React.ReactNode
}

const RedLabelInformation = React.forwardRef<HTMLDivElement, RedLabelInformationProps>(
  ({ className, size = 'default', children, icon, ...props }, ref) => {
    const defaultIcon = <span className="font-bold">!</span>

    return (
      <div ref={ref} className={redLabelInformationVariants({ size, className })} role="alert" {...props}>
        <div className={iconVariants({ size })}>{icon || defaultIcon}</div>

        <div className="flex-1">
          <span className="font-bold uppercase">ATENÇÃO: </span>
          {children}
        </div>
      </div>
    )
  }
)

RedLabelInformation.displayName = 'RedLabelInformation'

export { RedLabelInformation, redLabelInformationVariants }
